import { render, staticRenderFns } from "./FormNew.vue?vue&type=template&id=53d303be&"
import script from "./FormNew.vue?vue&type=script&lang=js&"
export * from "./FormNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports